import React from 'react';
import { Fecha as FechaComponent } from '../../../../../componentes/Fecha.js';
// Importamos las flechas de Heroicons junto con el ícono que ya tenías
import { TrashIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

export const TextoTruncado = ({ texto, limite = 60 }) => {
    const [expandido, setExpandido] = React.useState(false);

    // Si el texto es corto, lo mostramos completo sin botones
    if (!texto || texto.length <= limite) {
        return <span className="text-sm font-bold text-slate-800 mt-0.5 block">{texto}</span>;
    }

    // Si es largo, recortamos el texto según el límite definido
    const textoMostrado = expandido ? texto : `${texto.substring(0, limite)}...`;

    return (
        <div className="flex items-start justify-between gap-2 text-sm text-slate-800 mt-0.5 w-full font-medium">
            {/* El texto principal */}
            <span className={`font-normal break-words flex-1`}>
                {textoMostrado}
            </span>
            
            {/* Botón interactivo tipo Ícono */}
            <button
                type="button"
                onClick={() => setExpandido(!expandido)}
                className="p-1 rounded-md text-slate-400 hover:text-blue-600 hover:bg-blue-50 transition-colors focus:outline-none shrink-0"
                title={expandido ? 'Ver menos' : 'Ver más'}
            >
                {expandido ? (
                    <ChevronUpIcon className="h-4 w-4 stroke-[2.5]" />
                ) : (
                    <ChevronDownIcon className="h-4 w-4 stroke-[2.5]" />
                )}
            </button>
        </div>
    );
};